import View     from '@widesk-ui/components/View';
import AntdTabs from 'antd/lib/tabs';
import React    from 'react';

export type TabItem = {
	label: React.ReactNode;
	key?: string;
	children?: React.ReactNode;
	lazy?: boolean; // Si "true" le contenu n'est chargé que lorsqu'on clique sur l'onglet
}

export type TabsProps = {
	tabPosition?: 'left' | 'right' | 'top' | 'bottom';
	type?: 'line' | 'card' | 'editable-card';
	items: TabItem[];
	tabBarStyle?: React.CSSProperties;
	style?: React.CSSProperties;
	onChange?: (activeKey: any) => void,
	activeKey?: any;
}

export default function Tabs(props: TabsProps) {
	return (
		<View>
			<AntdTabs
				{...props}

				items={props.items.map((item, i) => {
					const id = String(i + 1);
					return { key: id, forceRender: !item.lazy, ...item };
				})}
			/>
		</View>
	);
}
